import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    ref: "fileLinkRef",
    type: "button",
    class: "reference-component__link reference-component__file-link",
    onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)), ["prevent","stop"]))
  }, [
    _createTextVNode(" #F - " + _toDisplayString(_ctx.text), 1)
  ], 32)), [
    [_directive_tooltip, {
      content: _ctx.text,
      theme: 'info-tooltip',
      placement: 'bottom',
      disabled: !_ctx.showFileNameTooltip
    }]
  ])
}